/* eslint-disable prettier/prettier */
import { emojiIconMap } from '../../utils/emojiIconMap';
import { CollapsibleSection } from '../file/CollapsibleSection';
import { ComparisonTable } from './ComparisonTable';

export const SignaturesComparisonSection = ({
  signatures,
  showDifferences,
}: {
  signatures: any[];
  showDifferences?: boolean;
}) => {
  if (!Array.isArray(signatures)) return null;
  const hasDifferences = signatures.some((signature) =>
    Object.values(signature).some((field: any) => field?.isDifferent),
  );

  if (showDifferences && !hasDifferences) return null;
  return (
    <CollapsibleSection title="Signatures" icon={emojiIconMap['Signatures']}>
      {signatures.map((sig, index) => (
        <div key={index} className="mb-4">
          <ComparisonTable
            data={sig}
            fieldLabels={{
              signatory: 'Signatory',
              signatureDate: 'Signature Date',
              isDigital: 'Digital Signature',
            }}
            firstLabel={`Signature ${index + 1}`}
            showDifferences={showDifferences}
          />
        </div>
      ))}
    </CollapsibleSection>
  );
};
